//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const INTFRAMEWORK_API_BASE_URL = new InjectionToken<string>('INTFRAMEWORK_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class IntframeworkFunctionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(INTFRAMEWORK_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAllEventDaysConfiguration(): Observable<EventDaysConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/EventDays/getall-eventdays";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEventDaysConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEventDaysConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventDaysConfigurationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventDaysConfigurationDto[]>;
        }));
    }

    protected processGetAllEventDaysConfiguration(response: HttpResponseBase): Observable<EventDaysConfigurationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventDaysConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllIntegrationConfiguration(): Observable<IntegrationJobConfigDto[]> {
        let url_ = this.baseUrl + "/api/IntegrationJob/getall-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIntegrationConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIntegrationConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationJobConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationJobConfigDto[]>;
        }));
    }

    protected processGetAllIntegrationConfiguration(response: HttpResponseBase): Observable<IntegrationJobConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationJobConfigDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobCodeQuery (optional) 
     * @return Success
     */
    getIntegrationConfigurationByJobCode(jobCodePath: string, jobCodeQuery?: string | undefined): Observable<IntegrationJobConfigDto> {
        let url_ = this.baseUrl + "/api/IntegrationJob/getconfiguration-by-jobcode/{jobCode}?";
        if (jobCodePath === undefined || jobCodePath === null)
            throw new Error("The parameter 'jobCodePath' must be defined.");
        url_ = url_.replace("{jobCode}", encodeURIComponent("" + jobCodePath));
        if (jobCodeQuery === null)
            throw new Error("The parameter 'jobCodeQuery' cannot be null.");
        else if (jobCodeQuery !== undefined)
            url_ += "jobCode=" + encodeURIComponent("" + jobCodeQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntegrationConfigurationByJobCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntegrationConfigurationByJobCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationJobConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationJobConfigDto>;
        }));
    }

    protected processGetIntegrationConfigurationByJobCode(response: HttpResponseBase): Observable<IntegrationJobConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationJobConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLastIntegrationJobRunByJobCode(body?: IntegrationJobRunRequest | undefined): Observable<LastIntegrationJobRun[]> {
        let url_ = this.baseUrl + "/api/IntegrationJob/getlastjobrun-by-jobcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastIntegrationJobRunByJobCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastIntegrationJobRunByJobCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LastIntegrationJobRun[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LastIntegrationJobRun[]>;
        }));
    }

    protected processGetLastIntegrationJobRunByJobCode(response: HttpResponseBase): Observable<LastIntegrationJobRun[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LastIntegrationJobRun.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getIntegrationJobConfiguration(): Observable<IntegrationJobConfigResponse> {
        let url_ = this.baseUrl + "/api/JobLog/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntegrationJobConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntegrationJobConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationJobConfigResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationJobConfigResponse>;
        }));
    }

    protected processGetIntegrationJobConfiguration(response: HttpResponseBase): Observable<IntegrationJobConfigResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationJobConfigResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getIntegrationJobBySourceFormat(): Observable<IntegrationJobConfigurationResponse[]> {
        let url_ = this.baseUrl + "/api/JobLog/joblogbysourceformat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntegrationJobBySourceFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntegrationJobBySourceFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationJobConfigurationResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationJobConfigurationResponse[]>;
        }));
    }

    protected processGetIntegrationJobBySourceFormat(response: HttpResponseBase): Observable<IntegrationJobConfigurationResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationJobConfigurationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getIntegrationJobByToken(): Observable<IntegrationJobsDto> {
        let url_ = this.baseUrl + "/api/JobLog/joblogbytoken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntegrationJobByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntegrationJobByToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationJobsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationJobsDto>;
        }));
    }

    protected processGetIntegrationJobByToken(response: HttpResponseBase): Observable<IntegrationJobsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationJobsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getIntegrationJobsByStatus(): Observable<IntegrationJobsDto> {
        let url_ = this.baseUrl + "/api/JobLog/jobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntegrationJobsByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntegrationJobsByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationJobsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationJobsDto>;
        }));
    }

    protected processGetIntegrationJobsByStatus(response: HttpResponseBase): Observable<IntegrationJobsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationJobsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkIfRecentProcessedFileDoNotHasFutureDate(): Observable<IntegrationJob> {
        let url_ = this.baseUrl + "/api/JobLog/processedFileDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfRecentProcessedFileDoNotHasFutureDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfRecentProcessedFileDoNotHasFutureDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationJob>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationJob>;
        }));
    }

    protected processCheckIfRecentProcessedFileDoNotHasFutureDate(response: HttpResponseBase): Observable<IntegrationJob> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationJob.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    create(): Observable<CreateIntegrationJobLogResponse> {
        let url_ = this.baseUrl + "/api/JobLog/save";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateIntegrationJobLogResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateIntegrationJobLogResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateIntegrationJobLogResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateIntegrationJobLogResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    createJobLogSubStatus(): Observable<CreateIntegrationJobLogSubStatusResponse> {
        let url_ = this.baseUrl + "/api/JobLog/substatus/save";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJobLogSubStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJobLogSubStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateIntegrationJobLogSubStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateIntegrationJobLogSubStatusResponse>;
        }));
    }

    protected processCreateJobLogSubStatus(response: HttpResponseBase): Observable<CreateIntegrationJobLogSubStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateIntegrationJobLogSubStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tokenQuery (optional) 
     * @return Success
     */
    getJobLogSubStatusByToken(tokenPath: string, tokenQuery?: string | undefined): Observable<IntegrationJobLogSubStatusResponse[]> {
        let url_ = this.baseUrl + "/api/JobLog/substatusbytoken/{token}?";
        if (tokenPath === undefined || tokenPath === null)
            throw new Error("The parameter 'tokenPath' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + tokenPath));
        if (tokenQuery === null)
            throw new Error("The parameter 'tokenQuery' cannot be null.");
        else if (tokenQuery !== undefined)
            url_ += "token=" + encodeURIComponent("" + tokenQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobLogSubStatusByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobLogSubStatusByToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationJobLogSubStatusResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationJobLogSubStatusResponse[]>;
        }));
    }

    protected processGetJobLogSubStatusByToken(response: HttpResponseBase): Observable<IntegrationJobLogSubStatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationJobLogSubStatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    update(): Observable<UpdateIntegrationJobLogResponse> {
        let url_ = this.baseUrl + "/api/JobLog/update";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateIntegrationJobLogResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateIntegrationJobLogResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateIntegrationJobLogResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateIntegrationJobLogResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateMetadata(): Observable<UpdateIntegrationJobLogResponse> {
        let url_ = this.baseUrl + "/api/JobLog/update-metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateIntegrationJobLogResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateIntegrationJobLogResponse>;
        }));
    }

    protected processUpdateMetadata(response: HttpResponseBase): Observable<UpdateIntegrationJobLogResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateIntegrationJobLogResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class CreateIntegrationJobLogResponse implements ICreateIntegrationJobLogResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    token?: string | undefined;
    jobGroupLogToken?: string | undefined;

    constructor(data?: ICreateIntegrationJobLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            this.token = _data["token"];
            this.jobGroupLogToken = _data["jobGroupLogToken"];
        }
    }

    static fromJS(data: any): CreateIntegrationJobLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIntegrationJobLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["token"] = this.token;
        data["jobGroupLogToken"] = this.jobGroupLogToken;
        return data;
    }
}

export interface ICreateIntegrationJobLogResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    token?: string | undefined;
    jobGroupLogToken?: string | undefined;
}

export class CreateIntegrationJobLogSubStatusResponse implements ICreateIntegrationJobLogSubStatusResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    token?: string | undefined;
    integrationJobLogSubStatus?: string | undefined;

    constructor(data?: ICreateIntegrationJobLogSubStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            this.token = _data["token"];
            this.integrationJobLogSubStatus = _data["integrationJobLogSubStatus"];
        }
    }

    static fromJS(data: any): CreateIntegrationJobLogSubStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIntegrationJobLogSubStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["token"] = this.token;
        data["integrationJobLogSubStatus"] = this.integrationJobLogSubStatus;
        return data;
    }
}

export interface ICreateIntegrationJobLogSubStatusResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    token?: string | undefined;
    integrationJobLogSubStatus?: string | undefined;
}

export class EventDaysConfigurationDto implements IEventDaysConfigurationDto {
    eventDaysConfigurationId?: number;
    daysToEvent?: number;
    entityType?: string | undefined;
    eventType?: string | undefined;

    constructor(data?: IEventDaysConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventDaysConfigurationId = _data["eventDaysConfigurationId"];
            this.daysToEvent = _data["daysToEvent"];
            this.entityType = _data["entityType"];
            this.eventType = _data["eventType"];
        }
    }

    static fromJS(data: any): EventDaysConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventDaysConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventDaysConfigurationId"] = this.eventDaysConfigurationId;
        data["daysToEvent"] = this.daysToEvent;
        data["entityType"] = this.entityType;
        data["eventType"] = this.eventType;
        return data;
    }
}

export interface IEventDaysConfigurationDto {
    eventDaysConfigurationId?: number;
    daysToEvent?: number;
    entityType?: string | undefined;
    eventType?: string | undefined;
}

export class IntegrationJob implements IIntegrationJob {
    integrationJobLogId?: number;
    integrationJobId?: number;
    jobCode?: string | undefined;
    token?: string | undefined;
    jobGroupLogToken?: string | undefined;
    startDateTime?: Date;
    endDateTime?: Date | undefined;
    totalRequestCount?: number;
    expectedEndDateTime?: Date | undefined;
    retry?: number;
    isScheduled?: boolean;
    integrationJobStatusId?: number;
    statusCode?: string | undefined;
    statusDisplayText?: string | undefined;
    metadataText?: string | undefined;
    metadata?: Metadata;
    configMetadata?: string | undefined;
    isSuccessRequired?: boolean;
    companyCode?: string | undefined;
    timeExtension?: number;
    expectedJobDuration?: number;
    isTerminal?: boolean;
    jobSubCategoryCode?: string | undefined;
    destinationType?: string | undefined;
    pipelineMetadata?: string | undefined;

    constructor(data?: IIntegrationJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationJobLogId = _data["integrationJobLogId"];
            this.integrationJobId = _data["integrationJobId"];
            this.jobCode = _data["jobCode"];
            this.token = _data["token"];
            this.jobGroupLogToken = _data["jobGroupLogToken"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            this.totalRequestCount = _data["totalRequestCount"];
            this.expectedEndDateTime = _data["expectedEndDateTime"] ? new Date(_data["expectedEndDateTime"].toString()) : <any>undefined;
            this.retry = _data["retry"];
            this.isScheduled = _data["isScheduled"];
            this.integrationJobStatusId = _data["integrationJobStatusId"];
            this.statusCode = _data["statusCode"];
            this.statusDisplayText = _data["statusDisplayText"];
            this.metadataText = _data["metadataText"];
            this.metadata = _data["metadata"] ? Metadata.fromJS(_data["metadata"]) : <any>undefined;
            this.configMetadata = _data["configMetadata"];
            this.isSuccessRequired = _data["isSuccessRequired"];
            this.companyCode = _data["companyCode"];
            this.timeExtension = _data["timeExtension"];
            this.expectedJobDuration = _data["expectedJobDuration"];
            this.isTerminal = _data["isTerminal"];
            this.jobSubCategoryCode = _data["jobSubCategoryCode"];
            this.destinationType = _data["destinationType"];
            this.pipelineMetadata = _data["pipelineMetadata"];
        }
    }

    static fromJS(data: any): IntegrationJob {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationJobLogId"] = this.integrationJobLogId;
        data["integrationJobId"] = this.integrationJobId;
        data["jobCode"] = this.jobCode;
        data["token"] = this.token;
        data["jobGroupLogToken"] = this.jobGroupLogToken;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["totalRequestCount"] = this.totalRequestCount;
        data["expectedEndDateTime"] = this.expectedEndDateTime ? this.expectedEndDateTime.toISOString() : <any>undefined;
        data["retry"] = this.retry;
        data["isScheduled"] = this.isScheduled;
        data["integrationJobStatusId"] = this.integrationJobStatusId;
        data["statusCode"] = this.statusCode;
        data["statusDisplayText"] = this.statusDisplayText;
        data["metadataText"] = this.metadataText;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        data["configMetadata"] = this.configMetadata;
        data["isSuccessRequired"] = this.isSuccessRequired;
        data["companyCode"] = this.companyCode;
        data["timeExtension"] = this.timeExtension;
        data["expectedJobDuration"] = this.expectedJobDuration;
        data["isTerminal"] = this.isTerminal;
        data["jobSubCategoryCode"] = this.jobSubCategoryCode;
        data["destinationType"] = this.destinationType;
        data["pipelineMetadata"] = this.pipelineMetadata;
        return data;
    }
}

export interface IIntegrationJob {
    integrationJobLogId?: number;
    integrationJobId?: number;
    jobCode?: string | undefined;
    token?: string | undefined;
    jobGroupLogToken?: string | undefined;
    startDateTime?: Date;
    endDateTime?: Date | undefined;
    totalRequestCount?: number;
    expectedEndDateTime?: Date | undefined;
    retry?: number;
    isScheduled?: boolean;
    integrationJobStatusId?: number;
    statusCode?: string | undefined;
    statusDisplayText?: string | undefined;
    metadataText?: string | undefined;
    metadata?: Metadata;
    configMetadata?: string | undefined;
    isSuccessRequired?: boolean;
    companyCode?: string | undefined;
    timeExtension?: number;
    expectedJobDuration?: number;
    isTerminal?: boolean;
    jobSubCategoryCode?: string | undefined;
    destinationType?: string | undefined;
    pipelineMetadata?: string | undefined;
}

export class IntegrationJobConfigDto implements IIntegrationJobConfigDto {
    integrationJobConfigurationId?: number;
    integrationJobCode?: string | undefined;
    integrationJobSubCategoryCode?: string | undefined;
    filePath?: string | undefined;
    maxRetryCount?: number;
    timeExtension?: number;
    sourceFormat?: string | undefined;
    integrationSchedule?: string | undefined;
    integrationScheduleStartTime?: Date | undefined;
    integrationScheduleEndTime?: Date | undefined;
    integrationScheduleTimeZone?: string | undefined;
    configMetadata?: string | undefined;
    expectedJobDuration?: number | undefined;
    isScheduled?: boolean | undefined;
    isSuccessRequired?: boolean;
    isDisabled?: boolean;
    companyCode?: string | undefined;
    schemaUrl?: string | undefined;
    destinationType?: string | undefined;
    pipelineMetadata?: string | undefined;

    constructor(data?: IIntegrationJobConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationJobConfigurationId = _data["integrationJobConfigurationId"];
            this.integrationJobCode = _data["integrationJobCode"];
            this.integrationJobSubCategoryCode = _data["integrationJobSubCategoryCode"];
            this.filePath = _data["filePath"];
            this.maxRetryCount = _data["maxRetryCount"];
            this.timeExtension = _data["timeExtension"];
            this.sourceFormat = _data["sourceFormat"];
            this.integrationSchedule = _data["integrationSchedule"];
            this.integrationScheduleStartTime = _data["integrationScheduleStartTime"] ? new Date(_data["integrationScheduleStartTime"].toString()) : <any>undefined;
            this.integrationScheduleEndTime = _data["integrationScheduleEndTime"] ? new Date(_data["integrationScheduleEndTime"].toString()) : <any>undefined;
            this.integrationScheduleTimeZone = _data["integrationScheduleTimeZone"];
            this.configMetadata = _data["configMetadata"];
            this.expectedJobDuration = _data["expectedJobDuration"];
            this.isScheduled = _data["isScheduled"];
            this.isSuccessRequired = _data["isSuccessRequired"];
            this.isDisabled = _data["isDisabled"];
            this.companyCode = _data["companyCode"];
            this.schemaUrl = _data["schemaUrl"];
            this.destinationType = _data["destinationType"];
            this.pipelineMetadata = _data["pipelineMetadata"];
        }
    }

    static fromJS(data: any): IntegrationJobConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationJobConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationJobConfigurationId"] = this.integrationJobConfigurationId;
        data["integrationJobCode"] = this.integrationJobCode;
        data["integrationJobSubCategoryCode"] = this.integrationJobSubCategoryCode;
        data["filePath"] = this.filePath;
        data["maxRetryCount"] = this.maxRetryCount;
        data["timeExtension"] = this.timeExtension;
        data["sourceFormat"] = this.sourceFormat;
        data["integrationSchedule"] = this.integrationSchedule;
        data["integrationScheduleStartTime"] = this.integrationScheduleStartTime ? this.integrationScheduleStartTime.toISOString() : <any>undefined;
        data["integrationScheduleEndTime"] = this.integrationScheduleEndTime ? this.integrationScheduleEndTime.toISOString() : <any>undefined;
        data["integrationScheduleTimeZone"] = this.integrationScheduleTimeZone;
        data["configMetadata"] = this.configMetadata;
        data["expectedJobDuration"] = this.expectedJobDuration;
        data["isScheduled"] = this.isScheduled;
        data["isSuccessRequired"] = this.isSuccessRequired;
        data["isDisabled"] = this.isDisabled;
        data["companyCode"] = this.companyCode;
        data["schemaUrl"] = this.schemaUrl;
        data["destinationType"] = this.destinationType;
        data["pipelineMetadata"] = this.pipelineMetadata;
        return data;
    }
}

export interface IIntegrationJobConfigDto {
    integrationJobConfigurationId?: number;
    integrationJobCode?: string | undefined;
    integrationJobSubCategoryCode?: string | undefined;
    filePath?: string | undefined;
    maxRetryCount?: number;
    timeExtension?: number;
    sourceFormat?: string | undefined;
    integrationSchedule?: string | undefined;
    integrationScheduleStartTime?: Date | undefined;
    integrationScheduleEndTime?: Date | undefined;
    integrationScheduleTimeZone?: string | undefined;
    configMetadata?: string | undefined;
    expectedJobDuration?: number | undefined;
    isScheduled?: boolean | undefined;
    isSuccessRequired?: boolean;
    isDisabled?: boolean;
    companyCode?: string | undefined;
    schemaUrl?: string | undefined;
    destinationType?: string | undefined;
    pipelineMetadata?: string | undefined;
}

export class IntegrationJobConfigResponse implements IIntegrationJobConfigResponse {
    integrationJobConfigurationId?: number;
    integrationJobCode?: string | undefined;
    integrationJobCategoryCode?: string | undefined;
    integrationJobSubCategoryCode?: string | undefined;
    integrationSourceCode?: string | undefined;
    filePath?: string | undefined;
    expectedFileFormat?: string | undefined;
    fileDateRegex?: string | undefined;
    sourceFormat?: string | undefined;
    isFileSourceFTP?: boolean;
    actualFileFormat?: string | undefined;
    dateFromFileName?: string | undefined;
    maxRetryCount?: number;
    expectedJobDuration?: number;
    timeExtension?: number;
    isSuccessRequired?: boolean;
    companyCode?: string | undefined;

    constructor(data?: IIntegrationJobConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationJobConfigurationId = _data["integrationJobConfigurationId"];
            this.integrationJobCode = _data["integrationJobCode"];
            this.integrationJobCategoryCode = _data["integrationJobCategoryCode"];
            this.integrationJobSubCategoryCode = _data["integrationJobSubCategoryCode"];
            this.integrationSourceCode = _data["integrationSourceCode"];
            this.filePath = _data["filePath"];
            this.expectedFileFormat = _data["expectedFileFormat"];
            this.fileDateRegex = _data["fileDateRegex"];
            this.sourceFormat = _data["sourceFormat"];
            this.isFileSourceFTP = _data["isFileSourceFTP"];
            this.actualFileFormat = _data["actualFileFormat"];
            this.dateFromFileName = _data["dateFromFileName"];
            this.maxRetryCount = _data["maxRetryCount"];
            this.expectedJobDuration = _data["expectedJobDuration"];
            this.timeExtension = _data["timeExtension"];
            this.isSuccessRequired = _data["isSuccessRequired"];
            this.companyCode = _data["companyCode"];
        }
    }

    static fromJS(data: any): IntegrationJobConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationJobConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationJobConfigurationId"] = this.integrationJobConfigurationId;
        data["integrationJobCode"] = this.integrationJobCode;
        data["integrationJobCategoryCode"] = this.integrationJobCategoryCode;
        data["integrationJobSubCategoryCode"] = this.integrationJobSubCategoryCode;
        data["integrationSourceCode"] = this.integrationSourceCode;
        data["filePath"] = this.filePath;
        data["expectedFileFormat"] = this.expectedFileFormat;
        data["fileDateRegex"] = this.fileDateRegex;
        data["sourceFormat"] = this.sourceFormat;
        data["isFileSourceFTP"] = this.isFileSourceFTP;
        data["actualFileFormat"] = this.actualFileFormat;
        data["dateFromFileName"] = this.dateFromFileName;
        data["maxRetryCount"] = this.maxRetryCount;
        data["expectedJobDuration"] = this.expectedJobDuration;
        data["timeExtension"] = this.timeExtension;
        data["isSuccessRequired"] = this.isSuccessRequired;
        data["companyCode"] = this.companyCode;
        return data;
    }
}

export interface IIntegrationJobConfigResponse {
    integrationJobConfigurationId?: number;
    integrationJobCode?: string | undefined;
    integrationJobCategoryCode?: string | undefined;
    integrationJobSubCategoryCode?: string | undefined;
    integrationSourceCode?: string | undefined;
    filePath?: string | undefined;
    expectedFileFormat?: string | undefined;
    fileDateRegex?: string | undefined;
    sourceFormat?: string | undefined;
    isFileSourceFTP?: boolean;
    actualFileFormat?: string | undefined;
    dateFromFileName?: string | undefined;
    maxRetryCount?: number;
    expectedJobDuration?: number;
    timeExtension?: number;
    isSuccessRequired?: boolean;
    companyCode?: string | undefined;
}

export class IntegrationJobConfigurationResponse implements IIntegrationJobConfigurationResponse {
    integrationJobConfigurationId?: number;
    integrationSchedule?: string | undefined;
    entityType?: string | undefined;
    integrationSubCategoryCode?: string | undefined;
    lastNotifyJobDate?: Date | undefined;
    integrationJobId?: number;
    integrationJobStatusId?: number;

    constructor(data?: IIntegrationJobConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationJobConfigurationId = _data["integrationJobConfigurationId"];
            this.integrationSchedule = _data["integrationSchedule"];
            this.entityType = _data["entityType"];
            this.integrationSubCategoryCode = _data["integrationSubCategoryCode"];
            this.lastNotifyJobDate = _data["lastNotifyJobDate"] ? new Date(_data["lastNotifyJobDate"].toString()) : <any>undefined;
            this.integrationJobId = _data["integrationJobId"];
            this.integrationJobStatusId = _data["integrationJobStatusId"];
        }
    }

    static fromJS(data: any): IntegrationJobConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationJobConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationJobConfigurationId"] = this.integrationJobConfigurationId;
        data["integrationSchedule"] = this.integrationSchedule;
        data["entityType"] = this.entityType;
        data["integrationSubCategoryCode"] = this.integrationSubCategoryCode;
        data["lastNotifyJobDate"] = this.lastNotifyJobDate ? this.lastNotifyJobDate.toISOString() : <any>undefined;
        data["integrationJobId"] = this.integrationJobId;
        data["integrationJobStatusId"] = this.integrationJobStatusId;
        return data;
    }
}

export interface IIntegrationJobConfigurationResponse {
    integrationJobConfigurationId?: number;
    integrationSchedule?: string | undefined;
    entityType?: string | undefined;
    integrationSubCategoryCode?: string | undefined;
    lastNotifyJobDate?: Date | undefined;
    integrationJobId?: number;
    integrationJobStatusId?: number;
}

export class IntegrationJobLogSubStatusResponse implements IIntegrationJobLogSubStatusResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    integrationJobLogSubStatusId?: number;
    integrationJobSubStatus?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;

    constructor(data?: IIntegrationJobLogSubStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            this.integrationJobLogSubStatusId = _data["integrationJobLogSubStatusId"];
            this.integrationJobSubStatus = _data["integrationJobSubStatus"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): IntegrationJobLogSubStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationJobLogSubStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["integrationJobLogSubStatusId"] = this.integrationJobLogSubStatusId;
        data["integrationJobSubStatus"] = this.integrationJobSubStatus;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IIntegrationJobLogSubStatusResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    integrationJobLogSubStatusId?: number;
    integrationJobSubStatus?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
}

export class IntegrationJobRunRequest implements IIntegrationJobRunRequest {
    jobCodes?: string[] | undefined;

    constructor(data?: IIntegrationJobRunRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jobCodes"])) {
                this.jobCodes = [] as any;
                for (let item of _data["jobCodes"])
                    this.jobCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): IntegrationJobRunRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationJobRunRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jobCodes)) {
            data["jobCodes"] = [];
            for (let item of this.jobCodes)
                data["jobCodes"].push(item);
        }
        return data;
    }
}

export interface IIntegrationJobRunRequest {
    jobCodes?: string[] | undefined;
}

export class IntegrationJobsDto implements IIntegrationJobsDto {
    integrationJobs?: IntegrationJob[] | undefined;

    constructor(data?: IIntegrationJobsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["integrationJobs"])) {
                this.integrationJobs = [] as any;
                for (let item of _data["integrationJobs"])
                    this.integrationJobs!.push(IntegrationJob.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntegrationJobsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationJobsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.integrationJobs)) {
            data["integrationJobs"] = [];
            for (let item of this.integrationJobs)
                data["integrationJobs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIntegrationJobsDto {
    integrationJobs?: IntegrationJob[] | undefined;
}

export class LastIntegrationJobRun implements ILastIntegrationJobRun {
    lastRunDate?: Date;
    integrationJobCode?: string | undefined;
    retry?: number | undefined;
    integrationJobStatus?: string | undefined;
    companyCode?: string | undefined;

    constructor(data?: ILastIntegrationJobRun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastRunDate = _data["lastRunDate"] ? new Date(_data["lastRunDate"].toString()) : <any>undefined;
            this.integrationJobCode = _data["integrationJobCode"];
            this.retry = _data["retry"];
            this.integrationJobStatus = _data["integrationJobStatus"];
            this.companyCode = _data["companyCode"];
        }
    }

    static fromJS(data: any): LastIntegrationJobRun {
        data = typeof data === 'object' ? data : {};
        let result = new LastIntegrationJobRun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastRunDate"] = this.lastRunDate ? this.lastRunDate.toISOString() : <any>undefined;
        data["integrationJobCode"] = this.integrationJobCode;
        data["retry"] = this.retry;
        data["integrationJobStatus"] = this.integrationJobStatus;
        data["companyCode"] = this.companyCode;
        return data;
    }
}

export interface ILastIntegrationJobRun {
    lastRunDate?: Date;
    integrationJobCode?: string | undefined;
    retry?: number | undefined;
    integrationJobStatus?: string | undefined;
    companyCode?: string | undefined;
}

export class Metadata implements IMetadata {
    emailData?: string | undefined;
    fileName?: string | undefined;
    totalRecords?: number;
    totalPassedRecords?: number;
    jobType?: string | undefined;
    fileProcessingDate?: Date | undefined;
    callbackUrl?: string[] | undefined;
    durableUrl?: string[] | undefined;
    lastCaregiverSync?: Date | undefined;
    path?: string | undefined;
    userEmailId?: string | undefined;
    jobData?: string | undefined;
    stagedBlobPath?: string | undefined;
    readonly emailDictionary?: { [key: string]: string; } | undefined;

    constructor(data?: IMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailData = _data["emailData"];
            this.fileName = _data["fileName"];
            this.totalRecords = _data["totalRecords"];
            this.totalPassedRecords = _data["totalPassedRecords"];
            this.jobType = _data["jobType"];
            this.fileProcessingDate = _data["fileProcessingDate"] ? new Date(_data["fileProcessingDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["callbackUrl"])) {
                this.callbackUrl = [] as any;
                for (let item of _data["callbackUrl"])
                    this.callbackUrl!.push(item);
            }
            if (Array.isArray(_data["durableUrl"])) {
                this.durableUrl = [] as any;
                for (let item of _data["durableUrl"])
                    this.durableUrl!.push(item);
            }
            this.lastCaregiverSync = _data["lastCaregiverSync"] ? new Date(_data["lastCaregiverSync"].toString()) : <any>undefined;
            this.path = _data["path"];
            this.userEmailId = _data["userEmailId"];
            this.jobData = _data["jobData"];
            this.stagedBlobPath = _data["stagedBlobPath"];
            if (_data["emailDictionary"]) {
                (<any>this).emailDictionary = {} as any;
                for (let key in _data["emailDictionary"]) {
                    if (_data["emailDictionary"].hasOwnProperty(key))
                        (<any>(<any>this).emailDictionary)![key] = _data["emailDictionary"][key];
                }
            }
        }
    }

    static fromJS(data: any): Metadata {
        data = typeof data === 'object' ? data : {};
        let result = new Metadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailData"] = this.emailData;
        data["fileName"] = this.fileName;
        data["totalRecords"] = this.totalRecords;
        data["totalPassedRecords"] = this.totalPassedRecords;
        data["jobType"] = this.jobType;
        data["fileProcessingDate"] = this.fileProcessingDate ? this.fileProcessingDate.toISOString() : <any>undefined;
        if (Array.isArray(this.callbackUrl)) {
            data["callbackUrl"] = [];
            for (let item of this.callbackUrl)
                data["callbackUrl"].push(item);
        }
        if (Array.isArray(this.durableUrl)) {
            data["durableUrl"] = [];
            for (let item of this.durableUrl)
                data["durableUrl"].push(item);
        }
        data["lastCaregiverSync"] = this.lastCaregiverSync ? this.lastCaregiverSync.toISOString() : <any>undefined;
        data["path"] = this.path;
        data["userEmailId"] = this.userEmailId;
        data["jobData"] = this.jobData;
        data["stagedBlobPath"] = this.stagedBlobPath;
        if (this.emailDictionary) {
            data["emailDictionary"] = {};
            for (let key in this.emailDictionary) {
                if (this.emailDictionary.hasOwnProperty(key))
                    (<any>data["emailDictionary"])[key] = (<any>this.emailDictionary)[key];
            }
        }
        return data;
    }
}

export interface IMetadata {
    emailData?: string | undefined;
    fileName?: string | undefined;
    totalRecords?: number;
    totalPassedRecords?: number;
    jobType?: string | undefined;
    fileProcessingDate?: Date | undefined;
    callbackUrl?: string[] | undefined;
    durableUrl?: string[] | undefined;
    lastCaregiverSync?: Date | undefined;
    path?: string | undefined;
    userEmailId?: string | undefined;
    jobData?: string | undefined;
    stagedBlobPath?: string | undefined;
    emailDictionary?: { [key: string]: string; } | undefined;
}

export class UpdateIntegrationJobLogResponse implements IUpdateIntegrationJobLogResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    token?: string | undefined;
    jobGroupLogToken?: string | undefined;
    integrationJobId?: number;
    oldJobStatus?: string | undefined;
    newJobStatus?: string | undefined;
    isTerminal?: boolean;
    isJobBelongsToGroup?: boolean | undefined;

    constructor(data?: IUpdateIntegrationJobLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            this.token = _data["token"];
            this.jobGroupLogToken = _data["jobGroupLogToken"];
            this.integrationJobId = _data["integrationJobId"];
            this.oldJobStatus = _data["oldJobStatus"];
            this.newJobStatus = _data["newJobStatus"];
            this.isTerminal = _data["isTerminal"];
            this.isJobBelongsToGroup = _data["isJobBelongsToGroup"];
        }
    }

    static fromJS(data: any): UpdateIntegrationJobLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIntegrationJobLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["token"] = this.token;
        data["jobGroupLogToken"] = this.jobGroupLogToken;
        data["integrationJobId"] = this.integrationJobId;
        data["oldJobStatus"] = this.oldJobStatus;
        data["newJobStatus"] = this.newJobStatus;
        data["isTerminal"] = this.isTerminal;
        data["isJobBelongsToGroup"] = this.isJobBelongsToGroup;
        return data;
    }
}

export interface IUpdateIntegrationJobLogResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    token?: string | undefined;
    jobGroupLogToken?: string | undefined;
    integrationJobId?: number;
    oldJobStatus?: string | undefined;
    newJobStatus?: string | undefined;
    isTerminal?: boolean;
    isJobBelongsToGroup?: boolean | undefined;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}